import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

import { PATIENT_LEAD_STATUS_OPTIONS } from './constants';

export default function PatientLeadStatusEditCell({ id, field, value }) {
  const apiRef = useGridApiContext();

  return (
    <Autocomplete
      options={PATIENT_LEAD_STATUS_OPTIONS}
      value={value ?? null}
      onChange={(_, newValue) => {
        if (newValue) {
          apiRef.current.setEditCellValue({ id, field, value: newValue });
          apiRef.current.stopCellEditMode({ id, field });
        }
      }}
      onClose={(_, reason) => {
        if (reason !== 'selectOption') {
          apiRef.current.stopCellEditMode({ id, field });
        }
      }}
      isOptionEqualToValue={(option, selected) => option === selected}
      disableClearable
      fullWidth
      open
      sx={{ px: 1 }}
      renderInput={params => (
        <TextField
          {...params}
          autoFocus
          size="small"
          variant="standard"
          sx={{
            '.MuiInputBase-root': { '::before': { border: 'none !important' } },
            '.MuiInputBase-input': { fontSize: '0.875rem' }
          }}
        />
      )}
    />
  );
}
